import apiClient from "@/services/apiClient";

const getFileName = (contentDisposition, fallbackName) => {
  if (!contentDisposition) return fallbackName;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8\'\'([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1].replace(/["']/g, ""));

  const fileNameMatch = contentDisposition.match(/filename=["']?([^"';]+)["']?/i);
  return fileNameMatch?.[1]?.trim() || fallbackName;
};

export const adminPaymentService = {
  getPayments: async (filters = {}) => {
    const response = await apiClient.get("/AdminPayment/GetPayments", {
      params: filters,
    });

    return response.data;
  },

  downloadReceipt: async (paymentTransactionId, receiptNumber) => {
    const response = await apiClient.get(
      `/AdminPayment/${paymentTransactionId}/receipt`,
      { responseType: "blob" }
    );

    const fallbackName = `${receiptNumber || `Receipt-${paymentTransactionId}`}.pdf`;
    const fileName = getFileName(
      response.headers?.["content-disposition"],
      fallbackName
    );
    const fileUrl = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");

    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(fileUrl);
  },
};
